import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { ToastService } from 'src/app/shared/services/toast.service';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-recover-password-modal',
  templateUrl: './recover-password-modal.component.html',
  styleUrls: ['./recover-password-modal.component.scss']
})
export class RecoverPasswordModalComponent {
  @Input() email!: string;

  constructor(
    private readonly authService: AuthService,
    private readonly toastService: ToastService
  ) {
  }

  resend(): void {
    this.authService.forgotPassword(this.email).subscribe(() => this.toastService.toast('E-mail reenviado com sucesso', EMessageType.Information));    
  }
}
